import apiService from '@/services/apiService/dashboards';

export default {
  async create({ commit }, payload) {
    try {
      commit('startFetching');
      const response = await apiService.createOne(payload);
      commit('addDashboard', response);
      commit('finishFetching');

      return { success: true, dashboard: response };
    } catch (error) {
      console.error(error);
      commit('setError', error);
      commit('finishFetching');

      return { success: false, error };
    }
  },
  async deleteById({ commit }, id) {
    try {
      await apiService.deleteOneById(id);

      commit('removeDashboard', id);

      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  },
  async refresh({ commit, state }, { selectedAccountIds, page, limit, search, sortBy, sortDirection } = {}) {
    try {
      commit('startFetching');
      if (typeof page === 'number') {
        state.page = page;
      }
      if (typeof limit === 'number') {
        state.limit = limit;
      }
      if (typeof search === 'string') {
        state.search = search;
      }

      const actualLimit = limit || state.limit;
      const actualPage = page || state.page;
      const offset = (actualPage - 1) * actualLimit;

      let actualSearch = search || state.search;
      if (typeof actualSearch !== 'string') {
        actualSearch = null;
      }

      const response = await apiService.fetchAll({
        selectedAccountIds,
        limit: actualLimit,
        offset,
        search: actualSearch,
        sortBy,
        sortDirection,
      });
      commit('setDashboards', {
        selectedAccountIds,
        search: actualSearch,
        dashboards: response.dashboards,
      });
      commit('finishFetching');

      return response;
    } catch (error) {
      console.error(error);
      commit('failedFetching', error);

      return { success: false, error };
    }
  },
  async refreshOne({ commit }, { dashboardId }) {
    try {
      commit('startFetching');
      const response = await apiService.fetchOneById(dashboardId);
      commit('setDashboard', response);
      commit('finishFetching');

      return { success: true };
    } catch (error) {
      console.error(error);
      commit('failedFetching', error);

      return { success: false, error };
    }
  },
  async addWidget({ commit }, { dashboardId, widget: widgetData }) {
    try {
      const widget = await apiService.addWidget(dashboardId, widgetData);
      commit('addWidget', { dashboardId, widget });

      return { success: true, data: widget };
    } catch (error) {
      return { success: false, error };
    }
  },
  async updateWidgetOrder({ commit }, { dashboardId, widgetOrder }) {
    try {
      await apiService.updateWidgetOrder(dashboardId, widgetOrder);
      commit('updateWidgetOrder', { dashboardId, widgetOrder });

      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  },
  async removeWidget({ commit }, { dashboardId, widgetId }) {
    try {
      await apiService.removeWidget(dashboardId, widgetId);
      commit('removeWidget', { dashboardId, widgetId });

      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  },
  async changeDashboardConfig({ commit }, { dashboardId, defaultDateRange, parentDtwinId, name, customParameters }) {
    try {
      const dashboard = await apiService.updateDashboardConfig(dashboardId, {
        defaultDateRange,
        parentDtwinId,
        name,
        customParameters,
      });

      if (customParameters) {
        commit('updateDashboardProperty', {
          dashboardId,
          property: 'value.customParameters',
          value: customParameters,
        });
      }

      if (defaultDateRange) {
        commit('updateDashboardProperty', {
          dashboardId,
          property: 'value.defaultDateRange',
          value: defaultDateRange,
        });
      }

      if (parentDtwinId) {
        commit('updateDashboardProperty', {
          dashboardId,
          property: 'meta.parentDtwinId',
          value: parentDtwinId,
        });
      }

      if (name) {
        commit('updateDashboardProperty', {
          dashboardId,
          property: 'meta.name',
          value: name,
        });
      }

      return {
        success: true,
        dashboard,
      };
    } catch (error) {
      return { success: false, error };
    }
  },
  async changeWidgetConfig({ commit }, { dashboardId, widgetId, config }) {
    try {
      await apiService.updateWidgetConfig(dashboardId, widgetId, config);
    } catch (error) {
      return { success: false, error };
    }

    Object.keys(config).forEach((key) => {
      commit('updateWidgetProperty', { dashboardId, property: key, widgetId, value: config[key] });
    });

    return { success: true };
  },
};
